<div class="ibk-card-page">
	<div class="ibk-card-page__header">
		<ng-content select="[modal-header]"></ng-content>
	</div>
	<div class="ibk-card-page__subtitle">
		<ng-content select="[modal-subtitle]"></ng-content>
	</div>
	<div class="ibk-card-page__subtitle">
		<ng-content select="[modal-subtitle-2]"></ng-content>
	</div>
	<div class="ibk-card-page__body">
		<ng-content select="[modal-body]"></ng-content>
	</div>
</div>
